"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var Auth =
/*#__PURE__*/
function () {
  (0, _createClass2.default)(Auth, [{
    key: "createInstance",
    value: function createInstance() {
      return new Auth();
    }
  }]);

  function Auth() {
    (0, _classCallCheck2.default)(this, Auth);
    this.data = {
      auth: null,
      user: null,
      gates: null,
      portal: null
    };
    this.initialized = false;
  }

  (0, _createClass2.default)(Auth, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.initialized) {
        throw new Error('Auth Utils: Cannot be initialized twice. Use getInstance() if you ' + 'need to create multiple instances.');
      }

      this.initialized = true;
      return (0, _userInfo.default)().then(function (_ref) {
        var user = _ref.user,
            gates = _ref.gates,
            portal = _ref.portal;
        _this.data = {
          user: user,
          gates: gates,
          portal: portal
        };
        return _this.data;
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.data;
    }
  }]);
  return Auth;
}();

var _default = new Auth();

exports.default = _default;
module.exports = exports.default;